import React, { Component } from 'react';
import { Form, Field, change } from 'redux-form';
import { get } from 'lodash';
import { Grid, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import StyledLabel from 'components/atoms/inputs/Label';
import ButtonStandardPrimary from 'components/atoms/buttons/standard/Primary';
import ColorPickerField from 'components/molecules/ColorPickerField';
import FileInput from 'components/atoms/inputs/FileInput';
import PreviewBranding from 'components/molecules/PreviewBranding';

const StyledGrid = styled(Grid) `
     font-size: 1em;
     padding-top: 16px;
     margin-left: -15px;
     line-height: 16px;
     color: #000000;
`;

const brandingDefaults = {
    headerBarColor: '#000',
    sideBarColor: '#0B3446',
    highlightColor: '#FBAD19'
};


class EditBrandBrandingForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            brand: get(props, 'brand.name', null),
            headerBarColor: get(props, 'brand.branding.headerBarColor', brandingDefaults.headerBarColor),
            sideBarColor: get(props, 'brand.branding.sideBarColor', brandingDefaults.sideBarColor),
            highlightColor: get(props, 'brand.branding.highlightColor', brandingDefaults.highlightColor),
            buttonColor: get(props, 'brand.branding.buttonColor', brandingDefaults.buttonColor),
            logoUrl: get(props, 'brand.branding.logoUrl', null),
        };
    }

    isValidHex = value => /^#(?:[0-9a-fA-F]{3}){1,2}$/.test(value)

    handleColorChange = (event, newValue, oldValue, name) => {
        // name comes through as 'branding.whatever'
        const colorName = name.split('.')[1];
        this.setState({
            ...this.state,
            [colorName]: this.isValidHex(newValue) ? newValue : brandingDefaults[colorName]
        });
    };

    logoChangeCallBack = (data, remove) => {
        this.setState({
            ...this.state,
            logoUrl: remove ? null : data,
        });
        if (remove) this.props.dispatch(change('editBrandBranding', 'branding.removeLogo', true));
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const nextBrand = nextProps.brand.name;
        let nextState = null;

        if (nextBrand !== prevState.brand) {
            nextState = {
                brand: get(nextProps, 'brand.name', null),
                headerBarColor: get(nextProps, 'brand.branding.headerBarColor', brandingDefaults.headerBarColor),
                sideBarColor: get(nextProps, 'brand.branding.sideBarColor', brandingDefaults.sideBarColor),
                highlightColor: get(nextProps, 'brand.branding.highlightColor', brandingDefaults.highlightColor),
                buttonColor: get(nextProps, 'brand.branding.buttonColor', brandingDefaults.buttonColor),
                logoUrl: get(nextProps, 'brand.branding.logoUrl', null),
            };
        }
        return nextState;
    }

    render() {
        const { pristine } = this.props;
        return (
            <Form onSubmit={this.props.handleSubmit()} id="editBrandBrandingForm">
                <StyledGrid fluid>
                    <Row>
                        <Col sm={12} md={4}>
                            <StyledLabel>Header Bar Color</StyledLabel>
                            <Field component={ColorPickerField} placeholder='Ex #000000'
                                name='branding.headerBarColor' label='Header Bar Color' type='text' onChange={ this.handleColorChange }/>

                            <StyledLabel>Side Bar Color</StyledLabel>
                            <Field component={ColorPickerField} placeholder='Ex #0B3446'
                                name='branding.sideBarColor' label='Side Bar Color' type='text' onChange={ this.handleColorChange } />

                            <StyledLabel>Highlight Color</StyledLabel>
                            <Field component={ColorPickerField} placeholder='Ex #FBAD19'
                                name='branding.highlightColor' label='Highlight Color' type='text' onChange={ this.handleColorChange } />


                            <StyledLabel>Button Color</StyledLabel>
                            <Field component={ColorPickerField} placeholder='Ex #007EC5'
                                name='branding.buttonColor' label='Button Color' type='text' onChange={ this.handleColorChange } />

                            <StyledLabel>Brand Logo</StyledLabel>
                            <Field component={FileInput}
                                name='branding.image' label='image' type='file' brandIdAttr={this.props.brand.id} logoCallback={this.logoChangeCallBack} logoUrl={this.state.logoUrl || null } />

                            {/* <Field name="removeLogo" component={HiddenField} /> */}
                        </Col>
                        <Col xsHidden smHidden md={8}>
                            <PreviewBranding data={this.state} />
                        </Col>
                    </Row>
                    <br/>
                    <ButtonStandardPrimary disabled={pristine} type="submit">Submit</ButtonStandardPrimary>
                </StyledGrid>
            </Form>
        );
    }
}

EditBrandBrandingForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    brand: PropTypes.object
};

export default EditBrandBrandingForm;



// WEBPACK FOOTER //
// ./src/components/organisms/forms/EditBrandBranding.js